export const VIEW_MODES = [
    { id: "feed", translationKey: "activation.alerts.view-mode.feed" },
    { id: "metrics", translationKey: "activation.alerts.view-mode.metrics" },
] as const;

export type ViewModeItem = (typeof VIEW_MODES)[number];

export type AlertViewMode = ViewModeItem["id"];

import type { AlertTabId } from "./config";

export const DEFAULT_VIEW_MODE: AlertViewMode = "feed";

export const TABS_WITHOUT_METRICS: AlertTabId[] = ["seoAlerts", "ads"];
